import { useTranslation } from 'react-i18next'
import { Errors } from 'config'

export const useMapTwoFactorError = () => {
  const { t } = useTranslation()

  const mapError = (error: string) => {
    switch (error) {
      case Errors.InvalidVerificationCode:
      case Errors.MissingVerificationCode:
        return t('twoFactorErrors.invalidCode')
      case Errors.InvalidMultiFactorSession:
        return t('twoFactorErrors.sessionExpired')
      case Errors.TooManyRequests:
      case Errors.QuotaExceeded:
        return t('twoFactorErrors.tooManyRequests')
      case Errors.NetworkRequestFailed:
        return t('twoFactorErrors.network')
      default:
        return t('twoFactorErrors.unknown')
    }
  }
  return { mapError }
}
